import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AdminService } from '@app/services/admin.service';
import { Constants } from '@app/shared-module/constants';
import { GlobalResponse } from '@app/shared-module/models';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-activate-doctor-subscription',
  templateUrl: './activate-doctor-subscription.component.html',
  styleUrls: ['./activate-doctor-subscription.component.css']
})
export class ActivateDoctorSubscriptionDialogComponent implements OnInit {
  public headerTitle: string;
  subscriptionData: any;
  doctor_id: string;
  paymentDate: any;
  @BlockUI() blockUI: NgBlockUI;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    editableDateField: false,
    openSelectorOnInputClick: true,
    showClearDateBtn: true,
    // disableUntil: { year: this.current_date.getFullYear(), month: this.current_date.getMonth() + 1, day: this.current_date.getDate() }
  };
  constructor(
    public dialogRef: MatDialogRef<ActivateDoctorSubscriptionDialogComponent>,
    public datepipe: DatePipe,
    public toastr: ToastrService,
    private service: AdminService
  ) { }

  ngOnInit() {
  }

  onPaymentDateChanged = (event: IMyDateModel) => {
    this.paymentDate = event.formatted;
  }

  activateSubscription() {
    let extendedDate;
    if (this.paymentDate) {
      if (this.paymentDate.formatted) {
        extendedDate = this.paymentDate.formatted;
      }
    }
    const req_body = {
      extendedDate
    };
    this.blockUI.start();
    this.service.activateSubscription(req_body, this.doctor_id).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.dialogRef.close(res.result);
      }
    },
      (error: any) => {
        this.blockUI.stop();
        this.toastr.error(error);
      });
  }

}
